import { t } from 'i18next';
import { IntegrationAccordion } from '../../../common/components/IntegrationAccordion';
import React, { useState } from 'react';
import CrowdStrikeIcon from '../../../assets/images/crowdstrike-icon.svg';
import { CrowdStrike } from '../../../integrations/crowdstrike/models/CrowdStrike';
import { CheckCrowdStrikeIntegrationArgs, CrowdStrikeIntegrationArgs } from '../../../integrations/crowdstrike/services/CrowdStrikeRepository';
import { CrowdStrikeAccordionForm } from './CrowdStrikeAccordionForm';

type Props = {
  crowdStrike: CrowdStrike | null;
  isLoading: boolean;
  onTestClick: (args: CheckCrowdStrikeIntegrationArgs) => void;
  onConnectClick: (args: CrowdStrikeIntegrationArgs) => void;
  onUnlinkClick: () => void;
  canUpdate: boolean;
};

export const CrowdStrikeAccordion = (props: Props) => {
  const { crowdStrike: crowdStrike, isLoading, onConnectClick, onTestClick, canUpdate, onUnlinkClick } = props;
  const isCrowdStrikeEnabled = crowdStrike !== null;
  const [isExpanded, setIsExpanded] = useState(true);
  const handleAccordionClick = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <IntegrationAccordion
      isExpanded={isExpanded}
      onClick={handleAccordionClick}
      isLoading={isLoading}
      isConfigured={isCrowdStrikeEnabled}
      title={t('integrationList.crowdstrike.title')}
      subtitle={t('integrationList.crowdstrike.description')}
      icon={<CrowdStrikeIcon width="32" height="25" />}
      details={
        !isLoading && (
          <CrowdStrikeAccordionForm
            canUpdate={canUpdate}
            crowdStrike={crowdStrike}
            onUnlinkClick={onUnlinkClick}
            onConnectClick={onConnectClick}
            onTestClick={onTestClick}
          />
        )
      }
    />
  );
};
